import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import NotFound from '@/components/404.vue';
import ServerError from '@/components/500.vue';
import ErrorPage from '@/components/error-page.vue';
import UserLogin from '@/components/UserLogin.vue';
import MainLayout from '@/components/MainLayout.vue';
import ForbiddenAccess from '@/components/403.vue';
import layoutRoutes from './pageRouter';
import { ROUTES } from '@/config/constants';
// import tempRoutes from './tempRoutes';
// import systemRoutes from './systemRoutes';

const routes: Array<RouteRecordRaw> = [
    ...layoutRoutes,
    // ...systemRoutes,
    {
        path: '/',
        name: 'Home',
        component: MainLayout,
        meta: { requiresAuth: true }
    },
    {
        path: `/${ROUTES.LOGIN}`,
        name: 'Login',
        component: UserLogin
    },
    {
        path: `/${ROUTES.SERVER_ERROR}`,
        name: '500',
        component: ServerError
    },
    {
        path: `/${ROUTES.ERROR_PAGE}`,
        name: 'ErrorPage',
        component: ErrorPage
    },
    {
        path: `/${ROUTES.FORBIDDEN}`,
        name: 'ForbiddenAccess',
        component: ForbiddenAccess
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: NotFound
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

const routerPath: Array<String> = [
    
];

// 全局前置守卫
router.beforeEach((to, from, next) => {
    const isAuthenticated = !!localStorage.getItem('token'); // 检查是否有token
    const userRole = localStorage.getItem('role'); // 用户权限

    // 定义不同角色的权限
    const rolePermissions: Record<string, string[] | '*'> = {
        system: '*', // system 角色可以访问所有页面
        admin: [
            `/${ROUTES.DASHBOARD}`,
            `/${ROUTES.OPERATOR_DETAIL}/*`,
            `/${ROUTES.MNT_USER}`,
            `/${ROUTES.MNT_SITE}`,
            `/${ROUTES.MNT_SENSOR}`,
            `/${ROUTES.PERSONAL_SETTINGS}`,
        ],
        general: [
            `/${ROUTES.DASHBOARD}`,
            `/${ROUTES.OPERATOR_DETAIL}/*`,
            `/${ROUTES.MNT_SITE}`,
            `/${ROUTES.PERSONAL_SETTINGS}`,
        ]
    };

    const allowedRoutes = rolePermissions[userRole as keyof typeof rolePermissions];

    // system 角色可以访问所有页面
    const hasPermission = allowedRoutes === '*' || (Array.isArray(allowedRoutes) && allowedRoutes.some(route => {
        // 处理 `*` 通配符匹配
        if (route.endsWith('/*')) {
            const basePath = route.replace('/*', ''); 
            return to.path.startsWith(basePath);
        }
        return route === to.path; // 精确匹配路径
    }));

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isAuthenticated) {
            next(`/${ROUTES.LOGIN}`); // 未登录，跳转到登录页
        } else if (!hasPermission) {
            next(`/${ROUTES.NOT_FOUND}`); // 已登录但无权限，跳转 404
        } else {
            next(); // 允许访问
        }
    } else {
        next(); // 公开页面，允许访问
    }
});

export default router;